interface EditorialTitleProps {
  text: string;
}

/**
 * Multi-line editorial title: a `\n`-joined string alternates bold-uppercase lines (first/last)
 * with an italic didot line in between — e.g. "THE\n'ENFANT TERRIBLE'\nOF LUXURY".
 */
export function EditorialTitle({ text }: EditorialTitleProps) {
  const lines = text.split('\n');

  return (
    <div className="text-jncquoi-neutral-1000 flex w-full flex-col items-center gap-1 text-center">
      {lines.map((line, i) => {
        const isEdge = lines.length > 1 && (i === 0 || i === lines.length - 1);
        return isEdge ? (
          <p key={i} className="font-pp-neue-montreal text-[24px] leading-none font-semibold uppercase">
            {line}
          </p>
        ) : (
          <p key={i} className="font-didot pt-1 text-[36px] leading-[34px] tracking-[-1.8px] italic">
            {line}
          </p>
        );
      })}
    </div>
  );
}
